import { useState, useEffect } from "react";
import { Link } from "wouter";
import { Button } from "@/components/ui/button";

const CONSENT_KEY = "cookie_consent";
const CONSENT_COOKIE_NAME = "cookie_consent";

function setConsentCookie(value: string) {
  try {
    document.cookie = `${CONSENT_COOKIE_NAME}=${value}; path=/; max-age=31536000; SameSite=Lax`;
  } catch {
    // ignore
  }
}

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(CONSENT_KEY);
      if (stored === "accept" || stored === "reject") {
        setShowBanner(false);
        return;
      }
      setShowBanner(true);
    } catch {
      setShowBanner(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(CONSENT_KEY, "accept");
      setConsentCookie("accept");
    } catch {
      setConsentCookie("accept");
    }
    setShowBanner(false);
  };

  const reject = () => {
    try {
      localStorage.setItem(CONSENT_KEY, "reject");
      setConsentCookie("reject");
    } catch {
      setConsentCookie("reject");
    }
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-0 left-0 right-0 z-[100] border-t border-slate-200 bg-white/95 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] backdrop-blur-sm"
    >
      <div className="mx-auto max-w-4xl px-4 py-4 sm:px-6 sm:py-5">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex-1 pr-2">
            <p className="text-sm font-medium text-slate-800 sm:text-base">
              We use cookies to remember your preferences and to improve our site. We do not use advertising cookies.
              By clicking &quot;Accept&quot; you agree to our use of cookies, or choose &quot;Reject&quot; to use only essential cookies.
            </p>
            <Link href="/cookies" className="mt-2 inline-block text-sm text-[hsl(142,52%,25%)] underline hover:no-underline">
              Cookie Policy
            </Link>
          </div>
          <div className="flex shrink-0 flex-wrap items-center gap-2 sm:gap-3">
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={reject}
              className="border-slate-300 text-slate-700 hover:bg-slate-50"
              aria-label="Reject non-essential cookies"
            >
              Reject
            </Button>
            <Button
              type="button"
              size="sm"
              onClick={accept}
              className="bg-[hsl(142,52%,20%)] text-white hover:bg-[hsl(142,52%,24%)]"
              aria-label="Accept cookies"
            >
              Accept
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
